import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { authService } from "../services/AuthService";

export const refreshTokenInterceptor = (
  axiosInstance: AxiosInstance
): AxiosInstance => {
  axiosInstance.interceptors.request.use(async function (
    config: InternalAxiosRequestConfig
  ) {
    try {
      const ac = await authService.getAccessToken();
      if (ac) {
        config.headers = config.headers ?? ({} as Record<string, any>);
        config.headers.Authorization = `Bearer ${ac}`;
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  });

  axiosInstance.interceptors.response.use((response) => {
    return response;
  });
  return axiosInstance;
};
